import { useNavigate } from 'react-router';
import { MdList } from 'react-icons/md';
import { StyledButton } from '@app/components/button/Button';
import { url } from '@app/utils/constants';
import { StyledTooltip } from '@app/components/tooltip/Tooltip';

const NavToFLowListBtn = () => {
    const navigate = useNavigate();
    return (
        <div className="nav-to-flow-list-btn-wrapper">
            <StyledTooltip title="Return to Flow List (unsaved changes will be lost)">
                <StyledButton
                    type="primary"
                    color="blue"
                    icon={<MdList size={20} />}
                    iconOnly={true}
                    onClick={() => navigate(url.adminPortal.internalAdmin.agentFlows.list)}
                    aria-label="Navigate to Flow list"
                />
            </StyledTooltip>
        </div>
    );
};

export default NavToFLowListBtn;
